import React from 'react';
import { Star } from 'lucide-react';

/**
 * FavoriteButton Component
 * A toggleable star button for marking items as favorites
 *
 * @param {Object} props
 * @param {boolean} props.isFavorite - Whether the item is currently a favorite
 * @param {function} props.onToggle - Callback when the button is clicked
 * @param {number} [props.size=20] - Icon size in pixels
 * @param {boolean} [props.disabled=false] - Whether the button is disabled
 * @param {string} [props.className] - Additional CSS classes
 */
const FavoriteButton = ({
  isFavorite,
  onToggle,
  size = 20,
  disabled = false,
  className = ''
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!disabled && onToggle) {
      onToggle();
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`favorite-button ${isFavorite ? 'is-favorite' : ''} ${className}`}
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      style={{
        background: 'none',
        border: 'none',
        padding: 'var(--space-1)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 'var(--radius-md)',
        transition: 'all var(--transition-fast)',
        opacity: disabled ? 0.5 : 1
      }}
    >
      <Star
        size={size}
        fill={isFavorite ? 'var(--color-warning)' : 'none'}
        color={isFavorite ? 'var(--color-warning)' : 'var(--color-text-tertiary)'}
        style={{
          transition: 'all var(--transition-fast)',
          transform: isFavorite ? 'scale(1.1)' : 'scale(1)'
        }}
      />
    </button>
  );
};

export default FavoriteButton;
